// This file is AUTOGENERATED, do not edit it manually!!!

export const imageAnnotations = {
    apply: 'Применить',
    back: 'Вернуться к сообщениям',
    cancel: 'Отмена',
    comment: 'Оставить комментарий',
    commented_on_image: 'написал комментарий на изображение',
    comments: 'Комментарии',
    delete: 'Удалить',
    delete_comment: 'Удалить этот комментарий?',
    deleted_image: 'Изображение удалено',
    download: 'Загрузить изображение',
    edit: 'Редактировать',
    no_comment: 'Нет комментариев для показа',
    write_comment: 'Оставьте ваш комментарий',
};
